exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.navbar .saunamonitor {\n    text-transform: uppercase;\n    font-weight: bold;\n}\n\n.language-menu-item {\n    cursor: pointer;\n}\n.language-menu-text {\n    cursor: pointer;\n    text-transform: uppercase;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/header/header.component.css
// module id = ../../../../../src/app/header/header.component.css
// module chunks = main